import { render } from "./HiFormDialogHiveStandard.vue?vue&type=template&id=07a396ba"
import script from "./HiFormDialogHiveStandard.vue?vue&type=script&lang=js"
export * from "./HiFormDialogHiveStandard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__